import React, { useState } from "react";
import { ListGroup, ListGroupItem, Button, Collapse } from "reactstrap";
import {
  capitalize,
  getFeatureStatus,
  logout,
  getLowResolutionLink,
} from "../helper-methods";
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
  USC_2257_URL,
  COMMUNITY_GUIDELINES_URL,
  CONTACT_SUPPORT_URL,
  DEFAULT_PROFILE_PICTURE,
} from "../config";
import ConfigureString from "../components/ConfigureString";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import SvgIcons from "../components/SvgIcons";

const SidebarMenu = ({ isVisibleSidebar, toggleSideBar }) => {
  const history = useHistory();

  const userData = useSelector((state) => state?.userData);

  const [isOpenPoliciesCollapse, setIsOpenPoliciesCollapse] = useState(false);

  const isLiveEventActive = getFeatureStatus("event");
  const isPayPerViewActive = getFeatureStatus("ppv");
  const isVaultActive = getFeatureStatus("vault");
  // const isShoutoutActive = getFeatureStatus("shoutout");

  const _logout = () => {
    logout(history, true);
  };

  const _navigateTo = (route) => {
    setIsOpenPoliciesCollapse(false);
    if (isVisibleSidebar) {
      toggleSideBar();
    }
    history.push(route);
  };

  const _isActiveTab = (route) => {
    return history?.location?.pathname === route ? true : false;
  };

  return (
    <div className="customSidebar">
      <div className="userInfo-Sidebar">
        <div className="img120by120" style={{ width: 90, height: 90, marginBottom: 12 }}>
          <div className="imagePreview">
            <img
              src={
                getLowResolutionLink(userData?.user?.profilePicture) ||
                DEFAULT_PROFILE_PICTURE
              }
              onError={(e) =>
                (e.target.src =
                  getLowResolutionLink(userData?.user?.profilePicture) ||
                  DEFAULT_PROFILE_PICTURE)
              }
              alt="Avatar"
              loading="lazy"
            />
          </div>
          <div className="rankInMenu">
            <SvgIcons type="profilePro" />
          </div>
        </div>
        <h5>
          {userData?.user?.name?.first
            ? capitalize(userData?.user.name.first)
            : null}
        </h5>
        <p>{userData?.user?.username ? `@${userData?.user.username}` : null}</p>
      </div>
      <ListGroup>
        {isLiveEventActive && (
          <ListGroupItem
            className="customTopBorder"
            tag="a"
            active={_isActiveTab("/live-events")}
            onClick={() => _navigateTo("/live-events")}
          >
            <span>
              <img
                src={"/assets/img/sidemenu/live-event.png"}
                alt="Calendar"
                style={{ marginTop: -3 }}
                loading="lazy"
              />
            </span>
            <ConfigureString keyString={"event"} />
          </ListGroupItem>
        )}
        {isPayPerViewActive && (
          <ListGroupItem
            tag="a"
            active={_isActiveTab("/ppv")}
            onClick={() => _navigateTo("/ppv")}
          >
            <span>
              <img
                src={"/assets/img/sidemenu/ppv.png"}
                alt="Eye"
                style={{ height: 15, marginTop: -1 }}
                loading="lazy"
              />
            </span>
            <ConfigureString keyString={"ppv"} />
          </ListGroupItem>
        )}
        {isVaultActive && (
          <ListGroupItem
            tag="a"
            active={_isActiveTab("/vault")}
            onClick={() => _navigateTo("/vault")}
          >
            <span>
              <img
                src={"/assets/img/sidemenu/vault.png"}
                alt="Vault"
                style={{ height: 22, marginTop: -5, marginLeft: 1 }}
                loading="lazy"
              />
            </span>
            <ConfigureString keyString={"vault"} />
          </ListGroupItem>
        )}
        {/* {isShoutoutActive && (
            <ListGroupItem
              tag="a"
              active={_isActiveTab("/shoutout")}
              onClick={() => _navigateTo("/shoutout")}
            >
              <span>
                <i className="fa fa-bullhorn" />
              </span>
              <ConfigureString keyString={"shoutout"}/>
            </ListGroupItem>
          )} */}
        {/* <ListGroupItem
            tag="a"
            active={_isActiveTab("/products")}
            onClick={() => _navigateTo("/products")}
          >
            <span>
              <i className="fa fa-product-hunt" />
            </span>
            eStore
          </ListGroupItem> */}
        <ListGroupItem
          tag="a"
          active={_isActiveTab("/statement")}
          onClick={() => _navigateTo("/statement")}
        >
          <span>
            <i className="fa fa-dollar ml-1" />
          </span>
          Statement
        </ListGroupItem>

        <ListGroupItem
          tag="a"
          active={_isActiveTab("/followers-stats")}
          onClick={() => _navigateTo("/followers-stats")}
        >
          <span>
            <SvgIcons type="Top Fans" />
          </span>
          Top Fans
        </ListGroupItem>

        <ListGroupItem
          tag="a"
          active={_isActiveTab("/promotion")}
          onClick={() => _navigateTo("/promotion")}
          className="customTopBorder"
          style={{ marginTop: 31 }}
        >
          <span>
            <img
              src={"/assets/img/sidemenu/promotion.png"}
              alt="Promotion"
              style={{ height: 22 }}
              loading="lazy"
            />
          </span>
          Promotion Links
        </ListGroupItem>
        <ListGroupItem
          tag="a"
          active={_isActiveTab("/members")}
          onClick={() => _navigateTo("/members")}
        >
          <span>
            <img
              src={"/assets/img/sidemenu/users.png"}
              alt="Users"
              loading="lazy"
            />
          </span>
          Team Members
        </ListGroupItem>
        <ListGroupItem
          tag="a"
          active={_isActiveTab("/settings")}
          onClick={() => _navigateTo("/settings")}
        >
          <span>
            <img
              src={"/assets/img/sidemenu/settings.png"}
              alt="Settings"
              style={{ marginTop: -2 }}
              loading="lazy"
            />
          </span>
          Settings
        </ListGroupItem>
        {/* <ListGroupItem
            tag="a"
            active={_isActiveTab("/my-profile")}
            onClick={() => _navigateTo("/my-profile")}
          >
            <span>
              <i className="fa fa-user-o" />
            </span>
            My Profile
          </ListGroupItem> */}

        <ListGroupItem
          tag="a"
          active={_isActiveTab("/training")}
          onClick={() => _navigateTo("/training")}
          className="customTopBorder"
          style={{ marginTop: 31 }}
        >
          <span>
            <img
              src={"/assets/img/sidemenu/training.png"}
              alt="Training"
              style={{ marginTop: -1, height: 20 }}
              loading="lazy"
            />
          </span>
          Training
        </ListGroupItem>
        <ListGroupItem
          tag="a"
          active={_isActiveTab("/faq")}
          onClick={() => _navigateTo("/faq")}
        >
          <span>
            <i className="fa fa-question-circle-o" />
          </span>
          FAQ
        </ListGroupItem>
        <ListGroupItem
          tag="a"
          href={CONTACT_SUPPORT_URL}
          target="_blank"
          action
        >
          <span>
            <img
              src={"/assets/img/sidemenu/support.png"}
              alt="Support"
              style={{ marginTop: -2 }}
              loading="lazy"
            />
          </span>
          Support
        </ListGroupItem>
        <ListGroupItem
          className="d-flex flex-column"
          active={isOpenPoliciesCollapse}
          onClick={() => setIsOpenPoliciesCollapse(!isOpenPoliciesCollapse)}
        >
          <Button className="policyBtn" color="link">
            <div>
              <span>
                <img
                  src={"/assets/img/sidemenu/terms.png"}
                  alt="Privacy"
                  style={{ marginLeft: 1, height: 22 }}
                  loading="lazy"
                />
              </span>
              Policies
            </div>

            <i
              className={`fa fa-chevron-right ${
                isOpenPoliciesCollapse ? "rotateIcon" : ""
              }`}
            />
          </Button>
          <Collapse isOpen={isOpenPoliciesCollapse} style={{ paddingTop: 10 }}>
            <ListGroupItem
              tag="a"
              href={PRIVACY_POLICY_URL}
              target="_blank"
              action
            >
              <span>
                <img
                  src={"/assets/img/sidemenu/privacy.png"}
                  alt="Privacy"
                  style={{ marginTop: -2 }}
                  loading="lazy"
                />
              </span>
              Privacy
            </ListGroupItem>
            <ListGroupItem
              tag="a"
              href={TERMS_OF_SERVICE_URL}
              target="_blank"
              action
            >
              <span>
                <img
                  src={"/assets/img/sidemenu/terms.png"}
                  alt="Terms"
                  style={{ marginLeft: 1, height: 22 }}
                  loading="lazy"
                />
              </span>
              Terms
            </ListGroupItem>
            <ListGroupItem tag="a" href={USC_2257_URL} target="_blank" action>
              <span>
                <img
                  src={"/assets/img/sidemenu/privacy.png"}
                  alt="Compliance"
                  style={{ marginTop: -2 }}
                  loading="lazy"
                />
              </span>
              18 USC 2257
            </ListGroupItem>
            <ListGroupItem
              tag="a"
              href={COMMUNITY_GUIDELINES_URL}
              target="_blank"
              action
            >
              <span>
                <img
                  src={"/assets/img/sidemenu/terms.png"}
                  alt="Guidelines"
                  style={{ marginLeft: 1, height: 22 }}
                  loading="lazy"
                />
              </span>
              Community Guidelines
            </ListGroupItem>
          </Collapse>
        </ListGroupItem>

        <ListGroupItem
          tag="a"
          onClick={_logout}
          className="customTopBorder"
          style={{ marginTop: 31 }}
        >
          <span>
            <img
              src={"/assets/img/sidemenu/logout.png"}
              alt="Logout"
              style={{ height: 20, marginTop: -3 }}
              loading="lazy"
            />
          </span>
          Logout
        </ListGroupItem>
      </ListGroup>
    </div>
  );
};

export default SidebarMenu;
